import { type ReactNode, useEffect } from "react";
import { X } from "lucide-react";

interface ModalProps {
  title: string;
  description?: string;
  children: ReactNode;
  onClose: () => void;
  wide?: boolean;
}

export function Modal({ title, description, children, onClose, wide = false }: ModalProps) {
  useEffect(() => {
    const handleKey = (event: KeyboardEvent) => {
      if (event.key === "Escape") onClose();
    };
    window.addEventListener("keydown", handleKey);
    return () => window.removeEventListener("keydown", handleKey);
  }, [onClose]);

  return (
    <div className="modal-backdrop" onMouseDown={onClose} role="presentation">
      <section
        aria-modal="true"
        aria-labelledby="modal-title"
        className={`modal-card${wide ? " modal-card--wide" : ""}`}
        onMouseDown={(event) => event.stopPropagation()}
        role="dialog"
      >
        <header className="modal-card__header">
          <div>
            <p className="eyebrow">FUNNELBOARD</p>
            <h2 id="modal-title">{title}</h2>
            {description ? <p>{description}</p> : null}
          </div>
          <button aria-label="Tutup" className="icon-button" onClick={onClose} type="button">
            <X size={18} />
          </button>
        </header>
        <div className="modal-card__body">{children}</div>
      </section>
    </div>
  );
}

